<template>
  <v-app id="inspire">
    <app-header />
    <v-main app>
      <router-view />
    </v-main>
    <app-footer />
  </v-app>
</template>

<script>
import { AppHeader, AppFooter } from "@/app/shared/components";

export default {
  name: "PrivateLayout",
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style></style>
